var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgElectric(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.20459,
    width: 20,
    height: 20,
    rx: 10,
    fill: "#172536"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.16471 17.7046H8.3327L9.16471 11.8713H6.25269C5.77013 11.8713 5.77845 11.6046 5.93653 11.3213C6.09461 11.0379 5.97813 11.2546 5.99477 11.2213C7.06806 9.32126 8.68215 6.48792 10.8287 2.70459H11.6607L10.8287 8.53792H13.7407C14.1484 8.53792 14.2067 8.81292 14.1318 8.96292L14.0735 9.08792C10.7954 14.8296 9.16471 17.7046 9.16471 17.7046Z",
    fill: "#FDA536"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgElectric);
export default __webpack_public_path__ + "static/media/Electric.0a2f91d7d53b730586b5e7759da1b59d.svg";
export { ForwardRef as ReactComponent };